export const ownershipMarkerNullString = '-' as const;
